export const APIENDPOINT = process.env.VUE_APP_APIENDPOINT;
export const FILEENDPOINT = process.env.VUE_APP_FILEPENDPOINT;
export const SCREENSHOTENDPOINT = process.env.VUE_APP_SCREENSHOTENDPOINT;
export const LOCALE = process.env.VUE_APP_I18N_LOCALE;
export const FALLBACK_LOCALE = process.env.VUE_APP_I18N_FALLBACK_LOCALE;
export const VUE_APP_LOGGER_ENABLED: boolean = process.env.VUE_APP_LOGGER_ENABLED;
export const DEFAULTIMAGE = process.env.VUE_APP_DEFAULTIMAGE;
export const SEPARATE_SPA = process.env.VUE_APP_SEPARATE_SPA;
